<template>
  <section class="">
    <header class="lg:flex lg:justify-between lg:items-center">
      <h2 class="page-title tracking-wide text-xl text-center lg:text-left lg:align-left mb-2 lg:mb-0">Explore Downtown</h2>
      <nav class="text-center text-xs lg:text-sm font-semibold">
        <a
          href="#shopping"
          class="rounded-t md:rounded-r-none md:rounded-l block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold hover:bg-gold text-white cursor-default': (category.name == 'shopping') }"
          @click="changeCategory('shopping')">
            Shopping
        </a>
        <a
          href="#dine-drink"
          class="block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold-dark text-white': category.name == 'dine-drink' }"
          @click="changeCategory('dine-drink')">
            Dine &amp; Drink
        </a>
        <a
          href="#arts-culture"
          class="block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold-dark text-white': category.name == 'arts-culture' }"
          @click="changeCategory('arts-culture')">
            Arts &amp; Culture
        </a>
        <a
          href="#services"
          class="block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold-dark text-white': category.name == 'services' }"
          @click="changeCategory('services')">
            Services
        </a>
        <a
          href="#parking"
          class="block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold-dark text-white': category.name == 'parking' }"
          @click="changeCategory('parking')">
            Parking
        </a>
        <a
          href="#outdoors"
          class="rounded-b md:rounded-l-none md:rounded-r block md:inline py-2 px-4 no-underline bg-gold-lighter hover:bg-gold leading-loose text-gold-darker hover:text-gold-lightest"
          :class="{ 'bg-gold-dark text-white': category.name == 'outdoors' }"
          @click="changeCategory('outdoors')">
            Outdoors
        </a>
      </nav>
    </header>
    <div class="mt-2 flex-1">
      <div v-if="loading">
        Loading...
      </div>
      <div v-else>
        <div v-if="locations.length > 0" class="flex flex-wrap justify-center lg:justify-left items-stretch -mx-2">
          <div v-for="location in locations" class="w-full lg:w-1/3 my-4">
            <card v-bind:location="location"></card>
          </div>
        </div>
        <div v-else>
          No locations found.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import card from './Card'
  import VueScrollTo from 'vue-scrollto'
  export default {
    props: ['defaultCategory'],
    components: {
      'card': card
    },
    data() {
      return {
        category: '',
        categories: [
          {
            name: 'shopping',
            label: 'Shopping'
          },
          {
            name: 'dine-drink',
            label: 'Dine & Drink'
          },
          {
            name: 'arts-culture',
            label: 'Arts & Culture'
          },
          {
            name: 'services',
            label: 'Services'
          },
          {
            name: 'parking',
            label: 'Parking'
          },
          {
            name: 'outdoors',
            label: 'Outdoors'
          }
        ],
        locations: [],
        loading: true
      }
    },
    mounted() {
      this.changeCategory(this.hasHash())
    },
    methods: {
      changeCategory(category) {
        this.category = this.findCategory(category)
        this.getLocations()
        window.events.$emit('updateCategory', category)
      },
      getLocations() {
        axios.get('/api/v1/category/' + this.category.name)
          .then(({data}) => {
            this.locations = data.locations
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
          })
      },
      findCategory(newCategory) {
        return this.categories.find(category => category.name == newCategory)
      },
      hasHash() {
        if (window.location.hash) {
          return window.location.hash.replace('#', '')
        }
        return this.defaultCategory
      }
    }
  }
</script>


<!-- <script>
//   export default
//   {
//     props: ['defaultCategory'],
//     data() {
//       return {
//         category: this.defaultCategory,
//         categories: [
//           {
//             label: 'shopping',
//             name: 'Shopping'
//           },
//           {
//             label: 'dine-drink',
//             name: 'Dine & Drink'
//           },
//           {
//             label: 'arts-culture',
//             name: 'Arts & Culture'
//           },
//           {
//             label: 'services',
//             name: 'Services'
//           },
//           {
//             label: 'parking',
//             name: 'Parking'
//           },
//           {
//             label: 'outdoors',
//             name: 'Outdoors'
//           }
//         ],
//         locations: []
//       }
//     },
//     created() {
//       // this.getLocations()
//       window.events.$on('updateCategory', category => {
//         this.category = this.currentCategory
//         this.getLocations()
//       })
//     },
//     computed: {
//       sponsor() {
//         return this.locations.map( (location) => {
//           return location.sponsor = (location.sponsor === true) ? true : false
//         })
//       },
//       currentCategory () {
//         return this.categories.find(category => category.label == this.category)
//       }
//     },
//     methods: {
//       getLocations() {
//         axios.get('/api/v1/category/' + this.currentCategory.label)
//         .then(({data}) => {
//           this.locations = data.locations
//         })
//       },
//       changeCategory(category) {
//         // this.category = this.categories.find(category => category.label == this.category)
//         // console.log(this.category)

//         // this.currentCategory = category
//       }
//     }
//   }
</script> -->
